<template>
  <v-dialog v-model="dialog" persistent max-width="450" content-class="version-dialog">
    <v-card>
      <v-card-text class="pt-6 text-center">
        <p class="version-modal-title mb-2">{{ $t("VersionModal.Title") }}</p>
        <p class="version-modal-message mb-0">{{ $t("VersionModal.Message") }}</p>
      </v-card-text>
      <v-card-actions class="justify-center pb-6">
        <v-btn class="white--text" color="#279947" @click="reload">
          {{ $t("VersionModal.Reload") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "VersionModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<style>
.v-dialog.version-dialog.v-dialog--active.v-dialog--persistent {
  padding: 0 !important;
}
</style>

<style scoped>
.version-modal-title {
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #212121;
}

.version-modal-message {
  font-family: Roboto, sans-serif;
  font-size: 16px;
  color: #212121;
}

</style>
